import React, { useState, useEffect } from 'react';
import {
  Box,
  Card,
  Tooltip,
  TextField,
  Typography,
  IconButton,
  DialogContent,
  DialogActions,
} from '@material-ui/core';
import { AttachFile, Delete } from '@material-ui/icons';
import { ThemeProvider } from '@material-ui/core/styles';
import CardTitle from 'src/components/sharedComponents/CardTitle';
import { Autocomplete } from '@material-ui/lab';
import { getGDCClusters } from '@auteco/services/gdcServices';
import { Button, useStyles, theme } from './styles';

const Details = (props) => {
  const {
    files,
    form,
    handleBack,
    handleSubmit,
    onChangeInputs,
    handleDeleteFile,
  } = props;
  const classes = useStyles();
  const [clusters, setClusters] = useState([])
  const getClusters = async () => {
    const response = await getGDCClusters({ partner: 0 })
    if (response.cluster) {
      const filteredClusters = response.cluster.filter(item => item.nombre !== 'Ojo este no debe salir')
      setClusters(filteredClusters)
    }
  }

  useEffect(() => {
    getClusters()
  }, [])
  return (
    <>
      <CardTitle
        title="Formulario de detalles"
        subTitle="Completa el formulario para obtener la mayor información posible para realizar las pruebas"
      />
      <Box component="form" onSubmit={handleSubmit}>
        <Card>
          <DialogContent>
            <ThemeProvider theme={theme}>
              <Autocomplete
                options={clusters}
                style={{ width: '300px', marginBottom: '20px' }}
                getOptionLabel={(option) => option.nombre}
                renderInput={(params) => <TextField {...params} label="Cluster" variant='outlined' required />}
                onChange={(e, newValue) => onChangeInputs(newValue.id, 'cluster_id')}
              />
              <TextField
                value={form.titulo || ''}
                className={classes.inputs}
                onChange={(e) => onChangeInputs(e.target.value, 'titulo')}
                required
                fullWidth
                label="Titulo"
                variant="outlined"
              />
              <TextField
                value={form.resumen || ''}
                className={classes.inputs}
                onChange={(e) => onChangeInputs(e.target.value, 'resumen')}
                required
                fullWidth
                label="Resumen"
                variant="outlined"
                multiline
                minRows={6}
              />
              <TextField
                value={form.detalle || ''}
                className={classes.inputs}
                onChange={(e) => onChangeInputs(e.target.value, 'detalle')}
                required
                fullWidth
                label="Detalle"
                variant="outlined"
                multiline
                minRows={6}
              />
              <TextField
                value={form.indicadores || ''}
                className={classes.inputs}
                onChange={(e) => onChangeInputs(e.target.value, 'indicadores')}
                required
                fullWidth
                label="Indicadores"
                variant="outlined"
                multiline
                minRows={6}
              />
              <TextField
                value={form.resultados || ''}
                className={classes.inputs}
                onChange={(e) => onChangeInputs(e.target.value, 'resultados')}
                fullWidth
                label="Resultados"
                variant="outlined"
                multiline
                minRows={6}
              />
            </ThemeProvider>
            <Box>
              {files?.map((file, index) => (
                <Box key={file.id} className={classes.filesContainer}>
                  <Typography className={classes.fileName}>
                    {file.nombre_adjunto}
                  </Typography>
                  <IconButton onClick={() => handleDeleteFile(index)}>
                    <Delete />
                  </IconButton>
                </Box>
              ))}
            </Box>
          </DialogContent>
          <DialogActions>
            <Tooltip title="Adjuntar archivo">
              <IconButton component="label" variant="contained">
                <AttachFile />
                <input
                  type="file"
                  hidden
                  onChange={(e) => {
                    onChangeInputs(e.target.files, 'files');
                  }}
                />
              </IconButton>
            </Tooltip>
            <Button onClick={handleBack}>Volver</Button>
            <Button type="submit">Enviar</Button>
          </DialogActions>
        </Card>
      </Box>
    </>
  );
};

export default Details;
